// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"c67b112c","241":"9b338fe5","264":"f8767eaf","319":"99ea744d","428":"5bf245c3","479":"cbdd585c","506":"31052079","535":"c82c0034","581":"32627b78","638":"270e4587","791":"1d37bcbb","839":"99b6c2ae","881":"2ed412f9"}[chunkId] + ".chunk.js";
};